<app-header></app-header>

<!-- Ingredient Menu -->
<ion-menu
  side="start"
  menuId="ingredient-menu"
  contentId="main-content"
  type="overlay"
>
  <app-ai-list-ingredient-menu
    [title]="'Choose From Best Selling ' + (currentIngredient?.product?.summary?.categoryDescription || currentIngredient?.aiListItem?.sourceText || '')"
    [platformType]="platformService?.platformType"
    [ingredientsWithSelectionInfo$]="ingredientsWithSelectionInfo$"
    [loadingState$]="loadingState$"
    [loaded$]="aogSearchResultsLoaded$"
    [loading$]="aogSearchResultsLoading$"
    [selectedProduct$]="selectedProduct$"
    (cancel)="closeIngredientMenu()"
    (save)="saveIngredientSelection($event)"
  >
  </app-ai-list-ingredient-menu>
</ion-menu>

<ion-content id="main-content" class="gray-content-bg" scroll-y="false">
  <div
    *ngIf="(viewModel$ | async) as viewModel"
    class="full-height overflow-y-scroll"
    cdkVirtualScrollingElement
  >
    <div class="header-container">
      <ion-grid class="auto-height" [fixed]="true">
        <div *ngIf="platformService?.platformType === platformRef.desktop">
          <app-breadcrumbs
            [breadcrumbs]="viewModel?.breadcrumbs"
          ></app-breadcrumbs>
        </div>
        <div class="padding-top-full">
          <span
            data-cy="ai-list-name"
            class="page-title-oswald black font-size-title full-line-height"
            >{{ viewModel?.aiListName }}</span
          >
          <span
            class="half-padding-left black bold"
            *ngIf="platformService?.platformType !== platformRef.mobile"
            data-cy="product-count-label"
            >{{ viewModel?.numberOfProducts }} {{ 'i18n.common.products' |
            translate }}</span
          >
        </div>
        <ng-container
          [ngTemplateOutlet]="metaDataHeader"
          [ngTemplateOutletContext]="{ viewModel: viewModel }"
        >
        </ng-container>
      </ion-grid>
    </div>
    <!-- Only show if on the list detail page -->
    <div
      class="body-container flex align-items-center justify-center"
      [class.flex]="!!viewModel?.fileParse?.isParsingFiles || !!viewModel?.productMatch?.isMatchingProducts"
    >
      <ng-container
        *ngIf="!!viewModel?.fileParse?.isParsingFiles"
        [ngTemplateOutlet]="loadingContainer"
        [ngTemplateOutletContext]="{ viewModel: viewModel }"
      >
      </ng-container>
      <ion-grid
        *ngIf="!viewModel?.fileParse?.isParsingFiles && !viewModel?.productMatch?.isMatchingProducts"
        class="full-height"
        [fixed]="true"
      >
        <ion-row class="ion-align-items-center ion-padding-top">
          <ion-col size="auto" *ngIf="viewModel?.showSearchAndFilter">
            <ion-searchbar
              class="search"
              mode="md"
              placeholder="Search within your list"
              [(ngModel)]="searchKey"
              (ionInput)="onSearch($event)"
              (ionClear)="resetSearch()"
              data-cy="ai-list-searchbar"
            ></ion-searchbar>
          </ion-col>
          <ion-col
            [size]="platformService?.platformType === platformRef.tablet ? '1.75' : '1.25'"
            *ngIf="viewModel?.showSearchAndFilter"
          >
            <app-sort-and-filter-button
              [sortAndFilterCount]="viewModel?.selectedFilterCount"
              [sortAndFilterText]="'Filter'"
              [platformType]="platformService?.platformType"
              [disabled]="false"
              [showAddButton]="false"
              [onRecentPurchase]="false"
              [showClearAll]="false"
              (openSortAndFilterListModalEmitter)="openFilterModal(viewModel?.filterOptions)"
              data-cy="ai-list-filter-button"
            ></app-sort-and-filter-button>
          </ion-col>
          <span
            *ngIf="!viewModel?.fileParse?.isParsingFiles"
            class="matched-products-count"
            >{{ viewModel?.matchedProductsCount }}/{{
            viewModel?.numberOfProducts }} {{
            'i18n.lists.aiListPage.productsMatched' | translate }}{{
            viewModel?.hasLoadingItems ? '...' : '' }}
            <ion-spinner
              *ngIf="viewModel?.hasLoadingItems"
              name="circles"
              class="icon-size"
              style="margin-left: 8px"
            ></ion-spinner>
          </span>
        </ion-row>
        <cdk-virtual-scroll-viewport
          orientation="vertical"
          class="cdk-scroll full-height"
          appCustomVs
          [itemHeights]="viewModel?.itemHeights"
          [bufferAfter]="10"
          [bufferBefore]="10"
        >
          <app-ai-list-product-card
            *cdkVirtualFor="let item of viewModel?.items; let i = index; trackBy: trackItem"
            [viewModel]="item"
            [isOnline]="viewModel?.isOnline"
            (edited)="openIngredientMenu($event)"
          ></app-ai-list-product-card>
        </cdk-virtual-scroll-viewport>
      </ion-grid>
    </div>

    <app-footer></app-footer>
  </div>
</ion-content>

<ng-template #loadingContainer let-viewModel="viewModel">
  <div class="loading-container flex column align-items-center full-height">
    <img data-cy="frying-pan-image" src="assets/images/Frying-Pan.svg" />
    <span
      class="bold font-size-20"
      data-cy="reading-image-loading-text"
      *ngIf="!!viewModel?.fileParse?.isParsingFiles"
      >{{ 'i18n.lists.aiListPage.readingImage' | translate : { fileBeingParsed:
      viewModel?.fileParse?.fileBeingParsedDisplayText } }}...</span
    >
    <span
      class="padding-top-full black medium-font-weight"
      data-cy="free-to-explore-loading-text"
      *ngIf="!!viewModel?.fileParse?.isParsingFiles"
      >{{ 'i18n.lists.aiListPage.feelFreeToExplore' | translate }}.</span
    >
    <span
      style="padding-top: 0.5rem"
      data-cy="find-it-later-loading-text"
      *ngIf="!!viewModel?.fileParse?.isParsingFiles"
      class="black medium-font-weight"
    >
      {{ 'i18n.lists.aiListPage.youCanFindItLater' | translate }}
      <a [routerLink]="['/lists']" data-cy="my-lists-link" class="green"
        >{{ 'i18n.lists.myLists' | translate }}</a
      >
      {{ 'i18n.lists.aiListPage.page' | translate}}.
    </span>
  </div>
</ng-template>

<ng-template #metaDataHeader let-viewModel="viewModel">
  <div
    class="flex padding-top-full"
    [class.column]="platformService?.platformType === platformRef.mobile"
    [class.mobile-meta-data]="platformService?.platformType === platformRef.mobile"
    [class.font-size-14]="platformService?.platformType !== platformRef.desktop"
  >
    <span
      *ngIf="platformRef.mobile === platformService?.platformType"
      class="black"
      data-cy="product-count-label"
      >{{ viewModel?.numberOfProducts }} {{ 'i18n.common.products' | translate
      }}</span
    >
    <span class="black capitalize" data-cy="menu-type"
      >{{ 'i18n.lists.aiListPage.menuType' | translate }}{{ viewModel?.menuType
      | lowercase }}</span
    >
    <span
      *ngIf="viewModel?.numberOfFilesUploaded > 0"
      class="black"
      [class.meta-data-padding]="platformService?.platformType !== platformRef.mobile"
      data-cy="number-of-files"
      >{{ 'i18n.lists.aiListPage.filesUploaded' | translate }}{{
      viewModel?.numberOfFilesUploaded }}</span
    >
    <span
      *ngIf="!!viewModel?.ingredientPreference"
      class="black"
      [class.meta-data-padding]="platformService?.platformType !== platformRef.mobile"
      data-cy="ingredient-preference"
      >{{ 'i18n.lists.aiListPage.ingredientPreference' | translate }}{{
      viewModel?.ingredientPreference }}</span
    >
  </div>
</ng-template>
